import html from "./ParticipantInfoHeader.html"
import "./ParticipantInfoHeader.css"
import "./ProfilePhoto.js"

var module = angular.module("ResearchKitApplicationModule");

module.component('participantInfoHeaderDashboardComponent', {
	template: html,
	bindings: {
		"model": "<"
	},
	controller: 'participantInfoHeaderController',
	controllerAs: 'vm'
});

module.controller("participantInfoHeaderController", ["$scope", "ceUrl",
	function ($scope, ceUrl) {
		var vm = this;

		vm.getParticipantImageUrl = function () {
			return ceUrl.make('api/profilephoto/patient/' + vm.model.PatientID + "?size=ProfileHeader");
		};
	}
]);
